import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  LOGIN_SETTINGS_FEATURE_KEY,
  LoginSettingsState,
} from './login-settings.reducer';
import { isDefined } from '@lyceo/shared/util';
import { CallState, getError, LoadingState } from '@lyceo/shared/util-loading';

export const selectLoginSettingsState =
  createFeatureSelector<LoginSettingsState>(LOGIN_SETTINGS_FEATURE_KEY);

export const selectWebsite = createSelector(
  selectLoginSettingsState,
  (state) => state.website,
);

export const selectWebsiteSet = createSelector(selectWebsite, (website) =>
  isDefined(website),
);

export const selectSettings = createSelector(
  selectLoginSettingsState,
  (state) => state.settings,
);

export const selectWebsiteId = createSelector(
  selectSettings,
  (settings) => settings?.websiteId,
);

export const selectSettingsSet = createSelector(selectSettings, (settings) =>
  isDefined(settings),
);

export const selectSettingsCallState = createSelector(
  selectLoginSettingsState,
  (state) => state.settingsCallState,
);

export const selectSettingsLoading = createSelector(
  selectSettingsCallState,
  (callState: CallState) => callState === LoadingState.LOADING,
);

export const selectSettingsLoaded = createSelector(
  selectSettingsCallState,
  (callState: CallState) => callState === LoadingState.LOADED,
);

export const selectSettingsError = createSelector(
  selectSettingsCallState,
  (callState: CallState) => getError(callState),
);

export const selectSettingsFinished = createSelector(
  selectSettingsLoaded,
  selectSettingsError,
  (loaded, error) => loaded || !!error,
);
